import { atom } from 'recoil'

export const previewState = atom({
  key: 'messageEditPreviewState',
  default: {
    active: false,
    html: false,
    hasPersonalization: false,
    showPersonalization: false,
    dynamicContents: [],
    selectedDynamicContents: [],
    loading: false,
    autoSave: false,
    IdRecipient: undefined,
    recipient: undefined
  }
})

export const groupsState = atom({
  key: 'messageEditGroupsState',
  default: []
})

export const filtersState = atom({
  key: 'messageEditFiltersState',
  default: {
    options: [],
    optionGroups: []
  }
})

export const previewLastSelected = atom({
  key: 'messageEditLastSelected',
  default: {
    lastEmails: [],
    lastFilters: [],
    lastGroups: [],
    previewReferenceRecipient: {
      lastEmails: [],
      lastFilters: [],
      lastGroups: [],
      lastTypeSelected: null
    }
  }
})
